import { Card, CardContent, CardHeader, Grid } from '@mui/material';

import { InfoField, NO_DATA_PLACEHOLDER, Typography } from '@occc-app/design-system';
import { LocationAddressFragment } from '@occc/graphql';
import { formatFullAddress } from '@occc/utils-formatters';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';

type GeneralDetailsCardProps = {
  address?: LocationAddressFragment | null;
  phoneNumbers: string[];
  locationGroupName?: string;
};

export const GeneralDetailsCard = ({
  address,
  phoneNumbers,
  locationGroupName,
}: GeneralDetailsCardProps) => {
  const phoneNumber = phoneNumbers[0] ?? null;

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant='h6' component='h3'>
            General Details
          </Typography>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InfoField
              sx={{ m: 0 }}
              label='Location Group'
              value={locationGroupName || NO_DATA_PLACEHOLDER}
              noDataMessage=''
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <InfoField
              sx={{ m: 0 }}
              label='Phone Number'
              value={
                phoneNumber ? formatPhoneNumberNationalForUS(phoneNumber) : NO_DATA_PLACEHOLDER
              }
              noDataMessage=''
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <InfoField
              sx={{ m: 0 }}
              label='Address'
              value={formatFullAddress(address) || NO_DATA_PLACEHOLDER}
              noDataMessage=''
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
